import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilterMenu = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_9389_29639)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M25 10H23M25 16H20M25 22H20M11 24V17.5612C11 17.3532 11 17.2492 10.9796 17.1497C10.9615 17.0615 10.9315 16.9761 10.8905 16.8958C10.8443 16.8054 10.7793 16.7242 10.6494 16.5617L7.35061 12.4383C7.22066 12.2758 7.15569 12.1946 7.10948 12.1042C7.06849 12.0239 7.03853 11.9385 7.02042 11.8503C7 11.7508 7 11.6468 7 11.4388V9.6C7 9.03995 7 8.75992 7.10899 8.54601C7.20487 8.35785 7.35785 8.20487 7.54601 8.10899C7.75992 8 8.03995 8 8.6 8H17.4C17.9601 8 18.2401 8 18.454 8.10899C18.6422 8.20487 18.7951 8.35785 18.891 8.54601C19 8.75992 19 9.03995 19 9.6V11.4388C19 11.6468 19 11.7508 18.9796 11.8503C18.9615 11.9385 18.9315 12.0239 18.8905 12.1042C18.8443 12.1946 18.7793 12.2758 18.6494 12.4383L15.3506 16.5617C15.2207 16.7242 15.1557 16.8054 15.1095 16.8958C15.0685 16.9761 15.0385 17.0615 15.0204 17.1497C15 17.2492 15 17.3532 15 17.5612V21L11 24Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_9389_29639",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M4 8C4 5.79086 5.79086 4 8 4H24C26.2091 4 28 5.79086 28 8V24C28 26.2091 26.2091 28 24 28H8C5.79086 28 4 26.2091 4 24V8Z",
			fill: "white"
		})
	}) })]
});
export default SvgFilterMenu;
